module.exports = __webpack_public_path__ + "static/img/treasure_box_bg.56356ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/treasure_box_bg.png
// module id = cmKW
// module chunks = 215